import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";

const ViewDetailModel = ({ setViewDetail, selectedData }) => {
  const [detailType, setDetailType] = useState("1");

  const getStatus = (status) => {
    if (status === 1) {
      return <Unverified>Unverified</Unverified>;
    } else if (status === 2) {
      return <Vaccines>Vacant</Vaccines>;
    } else if (status === 3) {
      return <Linked>Linked</Linked>;
    } else if (status === 4) {
      return <Requested>Requested</Requested>;
    } else if (status === 5) {
      return <Occupied>Occupied</Occupied>;
    } else if (status === 6) {
      return <Moving>Moving Out</Moving>;
    } else if (status === 7) {
      return <Reserved>Reserved</Reserved>;
    }
  };

  const getKycStatus = (kycStatus) => {
    if (kycStatus === 1) {
      return <KycPending>Pending</KycPending>;
    } else if (kycStatus === 2) {
      return <KycIdUploaded>ID Uploaded</KycIdUploaded>;
    } else if (kycStatus === 3) {
      return <KycPersonalInfo>Personal Info</KycPersonalInfo>;
    } else if (kycStatus === 4) {
      return <KycSelfie>Selfie Uploaded</KycSelfie>;
    } else if (kycStatus === 5) {
      return <KycAgreement>Rent Agreement Done</KycAgreement>;
    } else if (kycStatus === 6) {
      return <KycPolice>Police Verification Done</KycPolice>;
    } else if (kycStatus === 7) {
      return <KycPan>PAN Verification Done</KycPan>;
    } else {
      return <KycPending>N/A</KycPending>;
    }
  };

  const getTenantId = (tenantId) => {
    if (tenantId) {
      return <PropertyId>#{tenantId}</PropertyId>;
    } else {
      return <Unverified>N/A</Unverified>;
    }
  };

  const getRent = (rent) => {
    if (rent > 0) {
      return <p>₹ {rent}</p>;
    } else {
      return <p>₹ 0</p>;
    }
  };

  const getTotalDues = (totalDues) => {
    if (totalDues > 0) {
      return <p>₹ {totalDues}</p>;
    } else {
      return <p>₹ 0</p>;
    }
  };

  const getPropertyType = (propertyType) => {
    if (propertyType === 1) {
      return <p>PG</p>;
    } else if (propertyType === 2) {
      return <p>Flat</p>;
    }
  };

  const getGender = (tenantPreference) => {
    if (tenantPreference === 1) {
      return <p>Male</p>;
    } else if (tenantPreference === 2) {
      return <p>Female</p>;
    } else {
      return <p>Both</p>;
    }
  };
  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          <Status>{getTenantId(selectedData?.tenantId) || "N/A"}</Status>
        </div>
        <Column>
          <FirstColumn>
            <SubHeading>Tenant Name</SubHeading>
            <Paragraph>{selectedData?.name || "N/A"}</Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Owner Name</SubHeading>
            <Paragraph>{selectedData?.clientName || "N/A"}</Paragraph>
          </SecondColumn>
        </Column>

        <Column>
          <FirstColumn>
            <SubHeading>Created At</SubHeading>
            <Paragraph>
              {moment(selectedData?.createdAt).format("LL") || "N/A"}
            </Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Updated At</SubHeading>
            <Paragraph>
              {moment(selectedData?.updatedAt).format("LL") || "N/A"}
            </Paragraph>
          </SecondColumn>
        </Column>

        <ButtonGroup>
          <TemplateButton
            isActive={detailType === "1"}
            onClick={() => setDetailType("1")}
          >
            Basic Details
          </TemplateButton>

          <TemplateButton
            ml
            isActive={detailType === "2"}
            onClick={() => setDetailType("2")}
          >
            Rent Details
          </TemplateButton>
        </ButtonGroup>
        <Seperator />

        <div className="h-[37vh] overflow-y-auto">
          {detailType === "1" && (
            <>
              <SingleItem
                name={"Phone Number"}
                value={selectedData?.mobile || "N/A"}
              />
              <SingleItem
                name={"Property Name"}
                value={selectedData?.propertyName || "N/A"}
              />
              <SingleItem
                name={"Room No."}
                value={selectedData?.roomNum || "N/A"}
              />
              <SingleItem name={"Floor"} value={selectedData?.floor || "N/A"} />
              <SingleItem
                name="Property Type"
                value={getGender(selectedData?.gender || "N/A")}
              />
              <SingleItem
                name="Property Type"
                value={getPropertyType(selectedData?.propertyType) || "N/A"}
              />

              <SingleItem
                name="Status"
                value={getStatus(selectedData?.status || "N/A")}
              />

              <SingleItem 
                name="KYC Status" 
                value={getKycStatus(selectedData?.kycStatus)} 
              />
                          </>
          )}

          {detailType === "2" && (
            <>
              <SingleItem
                name="Rent"
                value={getRent(selectedData?.rent || "0")}
              />
              <SingleItem
                name="Rental Cycle"
                value={selectedData?.rentalCycle || "N/A"}
              />
              <SingleItem
                name="Security"
                value={selectedData?.security || "N/A"}
              />
              <SingleItem
                name="Total Dues"
                value={getTotalDues(selectedData?.totalDues || "N/A")}
              />
              <SingleItem
                name="Due Date"
                value={selectedData?.dueDate || "N/A"}
              />
              <SingleItem
                name="Move In Date"
                value={moment(selectedData?.moveInDate || "N/A").format("YYYY-MM-DD")}
              />
            </>
          )}
        </div>
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value }) => (
  <div className="flex items-center py-1.5 border-b border-gray-100">
    <Name>{name}</Name> <span>:</span>
    <Value>
      {(name === "Security" || name === "Fine" || name === "Maintenance Fee") &&
        value !== "N/A" && <span className="mr-1">₹</span>}
      {value}
      {(name === "Agreement Period" ||
        name === "Notice Period" ||
        name === "Lock-In Period") && <span className="ml-1">months</span>}
      {name === "Grace Period" && <span className="ml-1">days</span>}
    </Value> 
  </div>
);

const TemplateButton = ({ isActive, ml, ...rest }) => {
  return (
    <button
      className={`pl-0 pr-2 font-medium text-sm relative ${
        isActive ? "text-blue-500" : "text-gray-400"
      } ${
        ml ? "ml-4" : ""
      } after:absolute after:top-7 after:left-0 after:w-full after:h-0.5 ${
        isActive ? "after:bg-blue-500" : ""
      }`}
      {...rest}
    >
      {rest.children}
    </button>
  );
};
const ButtonGroup = tw.div`flex items-center !gap-0 mt-6 `;
const Seperator = tw.div`w-full h-[0.07rem] bg-gray-200 my-2 `;
const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Name = tw.span`text-sm text-gray-500  w-32`;
const Value = tw.span`text-sm text-black font-medium w-80 px-6 `;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const Unverified = tw.div`border border-rose-600 text-rose-600 text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Vaccines = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Requested = tw.div`bg-lime-100 text-lime-700 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Occupied = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Reserved = tw.div`bg-orange-100 text-orange-700 text-xs border-orange-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Linked = tw.div`bg-purple-100 text-purple-700 text-xs border-purple-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Moving = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const KycPending = tw.div`bg-yellow-100 text-yellow-600 text-xs border border-yellow-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;
const KycIdUploaded = tw.div`bg-blue-100 text-blue-700 text-xs border border-blue-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;
const KycPersonalInfo = tw.div`bg-purple-100 text-purple-700 text-xs border border-purple-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;
const KycSelfie = tw.div`bg-pink-100 text-pink-700 text-xs border border-pink-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;
const KycAgreement = tw.div`bg-indigo-100 text-indigo-700 text-xs border border-indigo-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;
const KycPolice = tw.div`bg-orange-100 text-orange-700 text-xs border border-orange-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;
const KycPan = tw.div`bg-green-100 text-green-700 text-xs border border-green-300 px-2.5 py-1 inline-flex items-center justify-center rounded-full`;

export default ViewDetailModel;
